<template>
    <div style="background:white" class="ve-list-page">
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">   
            <div style="width:70px;line-height:30px" >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;font-weight:600 ">{{ $LANG('0138', '新增') }} </span></el-link>
            </div>
            <el-select v-model="selparam" filterable  :placeholder="$LANG('1675', '请选择列名')"   size="small" style="width:120px; ">
                <span v-for="item in tabArr" :key='item.key' >
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable  :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:300px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
 
            <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                <el-button type="danger" size="small" style="height:31px">
                    {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown"  >
                    <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                    <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
 
        </div> 
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:2px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"

                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="mat_quota"
                    ref="tableRef"
                >

            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div> 
 
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                        <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  class="item-width" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox>  
                                <el-input size="medium" :disabled="saveFlag" @focus="inputBtn(item,'', item.key)" v-else-if="item.EDCSS=='button'"   v-model="mainRow[item.FLDNO]" style="width:100%;border:1px solid #808695"> </el-input>     
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-toolbar" style="display:flex">
                    <span class="spanRow">  {{ $LANG('0053', '报价明细') }}</span>
                    <el-link  :underline="false" @click="dtlAdd" :disabled="saveFlag">
                        【<i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:white"></i><span style="font-size:12px;margin-right:5px;color:white"> {{ $LANG('0087', '新增明细') }}</span>】
                    </el-link>                 
                    <el-button size="mini" :disabled="saveFlag"  type="primary" icon="el-icon-circle-plus-outline" @click="addJob " style="height:28px;margin-top:3px;margin-left:15px">{{ $LANG('0168', '导入工序') }}</el-button>
                    <el-button size="mini" :disabled="saveFlag"  type="danger" icon="el-icon-remove-outline" @click="delJob " style="height:28px;margin-top:3px;margin-left:15px">{{ $LANG('0154', '删除工序') }}</el-button>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    ref="refdtl"
                    class="custom-table-border"
                    v-loading="loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    show-summary
                    :summary-method="getSummary"
                    style=" margin-top:-8px;"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :header-cell-style="headStyle"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding2"                    
                    :height="editHeight" 
                    highlight-current-row
                    @row-click="perClick" >  
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >                      
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='MATTYPE'" v-text="scope.row['CMATTY']"></span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-select :ref="'pos'+scope.$index+item.key" size="mini" v-if="item.key=='MATTYPE'" v-model="scope.row[item.key]">
                                    <el-option :label="$LANG('0424', '产成品')" value="PRD"></el-option>
                                    <el-option :label="$LANG('0443', '原材料')" value="MAT"></el-option>
                                    <el-option :label="$LANG('1798', '样板-模具-设计服务')" value="SMP"></el-option>
                                </el-select>
                                <el-select @change="modelChange"  clearable  v-else-if="item.key==='RATE'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <span v-for="item in taxArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                    </span>
                                </el-select>
                                <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-date-picker  :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                
                                <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template>
                    </el-table-column>             
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="perDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                        </template>
                    </el-table-column>                        
                </el-table>  
                <!-- <div class="one-toolbar">
                    <span class="spanRow"> 工序明细</span>
                </div>            -->
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="saveFlag" @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
 
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
 
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <el-dialog  v-dialogDrag   :visible.sync="impWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <job-win v-bind:tabCol ="tableCol" v-bind:v_random="v_rand" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="impWin=false" @child-sure="jobSure"></job-win>                
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 工序设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="jobSet" width="400px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0718', '工序明细') }}</span>
            </div> 
            <el-table  :data="jobData" 
                border                            
                size="small"
                :height="410" 
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                :header-cell-style="headStyle"
                :row-class-name="tabRowClass" 
                ref="refjob"
                class="custom-table-border"
                highlight-current-row > 
                <el-table-column type="index" :label="$LANG('0310', '序号')" width="50"></el-table-column>
                <el-table-column  v-for="(item,index ) in jobCol.filter(item=>item.key=='JOBNO'||item.key=='JOBNM') " :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :min-width="item.width">
                    <template slot-scope="scope">   
                        <span  v-text="scope.row[item.key]" style="width:100%"> </span> 
                    </template> 
                </el-table-column> 
                <el-table-column
                    :label="$LANG('0330', '操作')"
                    align="center"
                    width="70">
                    <template slot-scope="scope">                        
                        <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="jobDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                    </template>
                </el-table-column>  
            </el-table> 
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
                <span style="float:right">                 
                    <el-button type="info" @click="jobExit" size="small" style="margin-left:50px;" icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button   @click="jobOk" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > {{ $LANG('1638', '确定') }} </el-button>
                </span>
            </div>  
        </el-dialog> 
    </div>  
</template>
<script>
import pubWin from '../datamgt/pubwin.vue'  
 
import { getTabColOrData,getBaseData } from '../../api/user'
import { getDate } from '../../api/Select' 
import repWin from '../datamgt/repWin.vue' 
import jobWin from '../datamgt/pubmulti.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"mat_quota",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '109',
            fieldIdseq: '109',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
        })
    ],
    data () {
        return {
            jobSet:false,
            loadWin:false,
            initCol:[],
            v_path:'',
            v_random:0,
            v_rand:'',
            loading:false,
            t_loading:false,
            nextData:[],
            delJobData:[],
 
            v_idno:'',
            v_replist:[],
            repDlg:false,
 
 
            impWin:false,
            cltCol:[],
 
            reqData:[],
 
            repWin:false,
            repUrl:'',
     
            drawer:false,
 
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promptWin:false, 
            prompt:'',
            selparam3:'MATTYNM',
            oper3:'like',
            txtparam3:'',
            selparam4:'',
            oper4:'like',
            txtparam4:'',
 
            stfgCss:'',
 
            stfgColor:'',
            mainRow:{},
            input_hold:this.$LANG('1718', '请输入查询的值'),
 
            active:'', //二级菜单选中标志
            jobData:[],
            jobCol:[],
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            
            dtlData:[], //明细数据
            dtlCol:[],
            operArr:[],
            oper:'like',
 
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            v_seq:'',
            delArr:[],
            empArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            pageSize:50,
            goPage:'',
            notNull:[],
            current:1,
            taxArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            expBool:false, //确认
   
            pageList: [50,500,1000],
            supOption:[],
            v_idseq:'',
            repArr:[],
            chkIndex:'',
            v_tabRow:{},
            v_tabIndex:'',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            prodCol:[],
            btnWin:false,
 
            v_commit:true,
            v_loading:false,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1" 
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
            v_row:{},
            pageIndex:1,
        }
    },
    mounted () { 
 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','109','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','109','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //确认
                    this.expBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'ISOUT','N','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
   
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','109','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','109','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
 
        this.showkey()
        this.v_path =this.$route.path
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 340) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
 
    },
    components: {
        repWin,
        pubWin,
        jobWin,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#mat_quota"),
                name: "wave",
            })
            this.qryTabData() 
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: { 
        jobDel(row,index){
            this.jobData.splice(index,1)
            this.delJobData.push(JSON.parse(JSON.stringify(row)))
        },
        jobExit(){
            this.jobSet=false
            this.delJobData =[]
        },
        jobOk(){
            this.refreshJob()
            this.jobSet =false
        },
        initJob(){
            this.dtlCol.forEach((item,index)=>{   //初始化工序     
                if (item.key.indexOf('JOB#')>-1){
                    this.dtlCol.splice(index,1,Object.assign(item,{'thide':'Y',title:'#'}))
                }
            })
            this.jobData=[]
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                this.loadWin =true   
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'109',p_lstseq:'1',p_json:JSON.stringify(this.allData),p_action:'销售报价'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('1017', '销售报价')+'_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                }) 
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.openFieldSettingsDialog().catch(() => {})
            }
        },
 
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['POSTFG']=='未开始' ){
                return 'row-gray'
            }else if (row['POSTFG']=='进行中' ){
                return 'row-blue'
            }else if (row['POSTFG']=='已完成' ){
                return 'row-green'
            }else if (row['POSTFG']=='异常' ){
                return 'row-yellow'
            } else if (row['POSTFG']=='加急' ){
                return 'row-red'
            }else{
                return 'row-gray'
            } 
        },
        rowClass({row,rowIndex}){  //为 table数据添加 index 字段
            if (row['POSTFG']=='未开始' ){
                return 'row-gray'
            }else if (row['POSTFG']=='进行中' ){
                return 'row-blue'
            }else if (row['POSTFG']=='已完成' ){
                return 'row-green'
            }else if (row['POSTFG']=='异常' ){
                return 'row-yellow'
            } else if (row['POSTFG']=='加急' ){
                return 'row-red'
            }else{
                return 'row-gray'
            }   
        },
        headStyle({row,column}){
           
            if (column.property=='JOB#0'||column.property=='JOB#1'||column.property=='JOB#2'||column.property=='JOB#3'||column.property=='JOB#4'||column.property=='JOB#5'||column.property=='JOB#6'||column.property=='JOB#7'||column.property=='JOB#8'||column.property=='JOB#9'){
                return 'color:#389;font-weight:600'
            }
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='TAXPRC' ||column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(2)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        jobSure(obj){
            if (obj.length==0){
                this.promptWin =true
                this.prompt =this.$LANG('1676', '请选择工序')
            }else {                
                obj.forEach(item=>{
                    let v_bool =true
                    this.jobData.some(it=>{
                        if (it['JOBNO'] ==item['IDNO']){
                            v_bool =false
                        }
                    })
                    if (v_bool ){
                        let v_obj ={JOBNO:item['IDNO'],JOBNM:item['JOBNM'],LSTSEQ:''}
                        this.jobData.push(v_obj)
                    }
                })
                this.refreshJob()
                this.impWin =false
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                })
            }
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM'] } ))
 
                this.chkIndex =this.v_tabIndex
            }else if (this.v_key =='CLNTNO'){ 
                Object.assign(this.mainRow,{CLNTNO:obj['IDNO'],CLNTNM:obj['CLNTNM']  })     
            } 
            this.btnWin =false
        },
        modelChange(){
            this.$forceUpdate()
        },
        inputBtn(row,index, key){   
            this.v_key =key        
            this.v_random=Math.random()
            if (key=='CLNTNO'){
                this.v_table ='v_bs_clnt'
                this.tableCol =this.cltCol
                this.v_key2 =''
                this.v_value2 =''
                this.btnWin =true
            }else{
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_bs_matqry'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 ='PRD'
                this.btnWin =true
 
            } 
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'QTY'][0].focus()  
                    } 
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
 
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
 
        qtyPrc(row,index,key){
            let v_prc =0 ,v_shpfee=0,v_ctlfee=0,v_devfee=0 ,v_amt=0
            this.dtlCol.filter(item=>item.thide=='N').forEach(item=>{
                if (row[item.key] && (item.key).indexOf('JOB#')>-1){
                    v_prc =Number(v_prc) +Number(row[item.key])
                }
            })
            if (row['SHPFEE']){
                v_shpfee =Number(row['SHPFEE'])
            }
            if (row['CTLFEE']){
                v_ctlfee =Number(row['CTLFEE'])
            }
            if (row['DEVFEE']){
                v_devfee =Number(row['DEVFEE'])
            }
            if (row['AMT']){
                v_amt =Number(row['AMT'])
            }
            //CTLFEE ,DEVFEE
           
            row['TAXPRC']= (v_amt +v_prc+v_shpfee+v_ctlfee+v_devfee).toFixed(2)          
            
        },
        delJob(){
            this.jobSet =true
        },
        perClick(row){
            this.chkIndex =row.index  
        },
        addJob(row,index){
            this.v_rand='r'+Math.random() 
            this.impWin =true
            this.v_table ='v_bs_job'
            this.tableCol =this.jobCol
            this.v_key2 =''
            this.v_value2 =''
        },
        perDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row={'MATTYPE':'MAT'  }
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
         
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'109',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&  this.v_commit) {    
                let obj_ ={},amt_=0,actamt_=0,v_matFlag=false 
                
                //汇总明细金额
                this.dtlData.forEach(item=>{  
                    if (!item['MATNO']) {
                        v_matFlag =true
                    }    
 
                    if(item['TAXPRC']){
                        amt_=Number(amt_)+Number(item['TAXPRC'])
                    }
                })
                //应收金额
                if(this.mainRow['DISFEE']) {
                    actamt_=Number(amt_)-Number(this.mainRow['DISFEE'])
                }else{
                    actamt_=Number(amt_)
                }    
                if (this.dtlData.length==0){
                    this.promptWin =true
                    this.prompt =this.$LANG('0108', '明细记录')+this.$LANG('2051', '不能为空')
                }  else{
                    this.v_commit =false
                    Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid,AMT:amt_,ACTFEE:actamt_}) 
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(obj_), p_table:'SALE_PRC',frmid:'109'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            //明细保存：批量保存  res.idseq
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'SALE_PRCdtl',p_idseq:res.idseq,p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }
                            })
                            //明细删除
                            if (this.delArr.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delArr), p_table:'SALE_PRCdtl',p_idseq:res.idseq,p_action:'D' },
                                })
                            }
                            if (this.delJobData.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delJobData), p_table:'SALE_PRCjob',p_idseq:res.idseq,p_action:'D' },
                                })
                            }
                            //工序保存
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.jobData), p_table:'SALE_PRCJOB',p_idseq:res.idseq,p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }
                            })        
                            vm.drawer =false   
                            vm.getOrdList('')
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
 
        },
 
        //订单明细
        getOrdList(cond){
            this.loadingInstance.show() 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by idno desc',p_table:'V_SALE_PRC'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.loadingInstance.close() 
                })
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.loading =true
            getTabColOrData(this.v_url,'V_SALE_PRCdtl','idseq',idseq,'','','','', ' order by matno').then((res) => {
                this.dtlData=[]
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.loading =false
                    this.$refs['refdtl'].doLayout()
                })
            })
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.pageSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex=index
            this.tabData = this.allData.slice(_start,_end)
        },
        //状态变更
        stfgRec(row,val,index,v_comm){
            var vm=this ,v_cond='',v_chkdttm='',v_chkuser=''
            if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='' 
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\' ' 
            }
            let v_bool =false
            if( v_comm=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_bool =true
                }
            }
            if (v_bool){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1049', ' 与审核用户：')+row['CHKUSER']+this.$LANG('1646', '不同时不能弃审')
            }else{
                this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    type:'info',
                }).then(()=>{
                    var vm=this
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'SALE_PRC',p_cond: v_cond},
                    }).then(res=>{      
                        if(res.code =='200')  {
                            if (val=='X'){
                                this.tabData.splice(index,1)
                            }else{        
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm })           
                            }
                        }else{
                            this.prompt=res.result
                            this.promptWin =true
                        }        
                    })            
                }).catch(()=>{})
            }
        },
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{ 
               this.saveFlag=false
            }
            //获取工序
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:row['IDSEQ'],p_cond: '  order by SORTBY,LSTSEQ  ',p_table:'V_SALE_PRCJOB'},
            }).then(res=>{ 
                if (res.result.length>0){
                    this.jobData =res.result
                    //console.log(JSON.stringify(this.jobData))
                    this.refreshJob()
                }else{
                    this.initJob()               
                }
            })
            this.v_idseq=row['IDSEQ']
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true  
            this.delArr =[] 
            this.delJobData=[]
            this.v_commit=true
            this.getDtlData(row.IDSEQ) 
        },
        refreshJob(){   
            //先置于空
            this.dtlCol.forEach((item,index)=>{       
                if (item.key.indexOf('JOB#')>-1){
                    this.dtlCol.splice(index,1,Object.assign(item,{'thide':'Y',title:'#'}))
                }
            })                       
            this.$nextTick(()=>{
                //再赋值
                this.jobData.forEach((it,ind)=>{
                    if (it['JOBNM']) {
                        this.dtlCol.some((item,index)=>{       
                            if (Object.values(item).includes('JOB#'+ ind  )){
                                this.dtlCol.splice(index,1,Object.assign(item,{'thide':'N',title: it['JOBNM']}))
                            }
                        })
    
                    }
                }) 
                this.$refs['refdtl'].doLayout()
            })
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let v_cond ='' , v_oper='' ,v_edcss='' ,cond_=''
            if (this.selparam){ //列1
                this.tabArr.some(item=>{  
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }               
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and  '+item + v_oper +'\''+this.v_row[item] +'\''          
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''  
                        }
                    }
                }
            })
 
 
            this.getOrdList( v_cond)
 
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.qryTabData()
        } ,
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={DTTM:getDate('day'), STAFFNM:this.v_usernm, STFG:'N'}
            this.saveFlag=false
            this.dtlData=[]
            this.delJobData=[]
            this.initJob()
            this.v_commit=true
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
        enterDown(event){
            if (event.keyCode==13){
                this.qryTabData()
            }
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','109','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then((res) => {
                this.tabArr =[]
                this.vueCol =[]
                const mainFields =this.sortFieldRows(res.result)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                    })
                    let itcol =rowField
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex">
                                                <el-date-picker v-model={this.v_row[column.key]} value-format="yyyy-MM-dd" size="mini" placeholder="" style="width:100%" on-change={()=>this.qryTabData() }></el-date-picker>
        
                                            </div>
                                        </div>                                   
                                    )
                                }else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <input disabled={itcol.EDCSS=='image'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <input disabled={itcol.key=='SEL'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (column.key=='SEL' ){
                                    return ( 
                                        <el-checkbox disabled={row['STFG']!=='Y'} true-label="Y" false-label="N" v-model={row['SEL']} ></el-checkbox>
                                    )
                                }else if (column.key=='IDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repBtn( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }                                          
                                } else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', ' 清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:210,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='N'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.stfgRec(row,'Y',rowIndex,'审核')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.stfgRec(row,'X',rowIndex,'作废')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0257', '作废')}</span></el-link>
                                </div>                                
                            )
                        } else if (row['STFG']=='Y'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.stfgRec(row,'N',rowIndex,'弃审')}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>
 
                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','109','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','109','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.jobCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','94','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.cltCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .item-width{
        width: 32%;
        height: 20px ;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-one {
        width: 32%;
        height:40px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .row-red  {
        color: red;
    }
    .el-table .ok-row  {
        color: green;
        font-weight:700;
    }
    .el-table .row-gray  { //未开始颜色
        color: gray;
        font-weight:700;
    }
    .el-table .row-blue  { //进行中颜色
        color: blue;
        font-weight:700;
    }
    .el-table .row-green  { //已完成颜色
        color: green;
        font-weight:700;
    }
    .el-table .row-yellow  { //异常颜色
        color: rgb(255, 165, 0) ;
        font-weight:700;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
